import { DownloadOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { useApi } from '../api/useApi';
import useDynamicSelector from '../hooks/useDynamicSelector';
import { useRouting } from '../routing/routingProvider';
import { RootState } from '../store';
import ControlPanelButton from './ControlPanelButton';

interface ControlPanelExportCsvButtonProps {}

export const ControlPanelExportCsvButton: React.FC<ControlPanelExportCsvButtonProps> = () => {
    const [inProgress, setInProgress] = useState(false);
    const filterFlexible = useSelector<RootState, string | undefined>((state) => state.table.flexibleFilters);
    const orderBy = useSelector<RootState, string[] | undefined>((state) => state.table.orderBy);

    const checkedList = useDynamicSelector('table', 'checkedList');
    const { getUrlPath } = useRouting();

    const isItemsPage = getUrlPath().endsWith('items');

    const { schedule } = useApi();
    const onClick = async () => {
        setInProgress(true);
        try {
            const apiEndpoint = (isItemsPage ? schedule.exportScheduleItemsToCsv : schedule.exportTasksToCsv).bind(
                schedule,
            );

            await apiEndpoint({
                filterFlexible,
                orderBy,
                columns: checkedList.filter((column) => column !== 'action'),
            });
        } finally {
            setInProgress(false);
        }
    };
    return <ControlPanelButton loading={inProgress} icon={<DownloadOutlined />} title="Export CSV" onClick={onClick} />;
};
